import { MakeCall } from './createMakeCall';
import { ReviewSurvey } from './types/ReviewSurvey';

const getReviewSurvey = (makeCall: MakeCall) => (uuid: string) =>
  makeCall<ReviewSurvey>('GET', `/api/v2/review/survey/${uuid}`);
export { getReviewSurvey };
